import { ApiError } from 'api-new/generated';

export const formatError = (error: ApiError): string => {
  const body = error?.body as { title?: string } | undefined;

  return body?.title ?? error.message ?? 'Something went wrong';
};
